itsoftApp.createModule("scrollActions", ["startLoad"], function () {
    const module = this;
    let registeredPlugin = false;
    let registeredScrollTriggerPlugin = false;
    // const getScrollbarWidth = itsoftApp.utils.getScrollbarWidth;

    const libraries = {
        gsap: {
            name: "gsap",
            queue: [],
            started: false,
            loaded: false,
            scriptMore: "/assets/scripts/gsap/ScrollTrigger.min.js",
            script: "/assets/scripts/gsap/gsap.min.js"
        }
    }
    
    const initScrollActions = function (element, scrollTriggerFlag, cb, swiper) { 
        const initScrollExemplar = function () {
            if (!registeredPlugin) {
                registeredPlugin = true;

                if (!registeredScrollTriggerPlugin && scrollTriggerFlag) {
                    gsap.registerPlugin(ScrollTrigger);
                }
            }

            ScrollTrigger.clearScrollMemory();
            if (element.classList.contains("js-scroll-sections")) {
                let mm = gsap.matchMedia();

                const scrollLine = element.querySelector(".page__dashed-path");
                let params;
                let updateParams;
                let pathLength;


                if (scrollLine) {
                    params = itsoftApp.modules.dashAnimation.initCustomAnimation(scrollLine);
                    updateParams = params.updateParams;
                    pathLength = params.pathLength;
                }

                let itemInitial = element.querySelector('.js-scroll-item--initial');
                let itemInactive = element.querySelector(".js-scroll-item:not(.js-scroll-item--initial)");
                let thisPinWrap = element.querySelector('.js-pin-wrap');
                let activeBlock = element.querySelector(".js-active-block");
                let inactiveBlock = element.querySelector(".js-inactive-block");
                let nextSlideFlag = false;
                let prevSlideFlag = true;
                let prevItem = element.querySelector(".js-prev-item");
                let nextItem = element.querySelector(".js-next-item");
                let cbFlag = false;

                mm.add("(min-width: 1024px)", () => {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: element,
                            pin: true,
                            pinSpacing: "margin",
                            toggleActions: "play pause reverse pause",
                            scrub: true,
                            start: element.hasAttribute('data-start') ? element.getAttribute('data-start') : "center-=64px center",
                            onRefresh: (self) => {
                                if (cb && !cbFlag) {
                                    cbFlag = true;
                                    cb();
                                }
                            },
                            onUpdate: (self) => {
                            if (self.progress >= 0.9 && !nextSlideFlag && self.direction == 1) {
                                nextSlideFlag = true;
                                prevSlideFlag = false;
                                prevItem.classList.remove("js-active");
                                nextItem.classList.add("js-active");

                                gsap.timeline().addLabel("start")
                                .to(activeBlock, {opacity: 0, duration: 0.5}, "start")
                                .to(inactiveBlock, {opacity: 1, duration: 0.5}, "start")
                            } else if (self.progress < 0.9 && !prevSlideFlag && self.direction == -1) {
                                prevSlideFlag = true;
                                nextSlideFlag = false;
                                prevItem.classList.add("js-active");
                                nextItem.classList.remove("js-active");

                                gsap.timeline().addLabel("start")
                                .to(activeBlock, {opacity: 1, duration: 0.5}, "start")
                                .to(inactiveBlock, {opacity: 0, duration: 0.5}, "start");
                            } 
                            },
                            end: () => "+=" + itemInitial.clientHeight
                        }
                    });

                    tl.addLabel("start")
                        .set(inactiveBlock, {opacity: 0})
                        .fromTo(itemInactive, {scale: 0.8}, {scale: 0.8, duration: 0.2}, "start")
                        .addLabel("afterStart")
                        .fromTo(itemInactive, {scale: 0.8}, {scale: 1, duration: 0.6}, "afterStart")
                        .fromTo(itemInactive, {xPercent: 56.5}, {xPercent: 0, duration: 0.6}, "afterStart")
                        .addLabel("beforeEnd")
                        .fromTo(itemInactive, {scale: 1}, {scale: 1, duration: 0.2}, "beforeEnd");
                });

                mm.add("(max-width: 1023px)", () => {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: element,
                            pin: true,
                            pinSpacing: "padding",
                            start: element.hasAttribute('data-start') ? element.getAttribute('data-start') : "top-=48px top",
                            end: () => "+=" + 682,
                            scrub: true,
                            onRefresh: (self) => {
                                if (cb && !cbFlag) {
                                    cbFlag = true;
                                    cb();
                                }
                            },
                        //   markers: true
                        }
                    });

                    // add animations and labels to the timeline
                    tl.addLabel("start")
                        .fromTo(itemInactive, {yPercent: 50, backgroundColor: "rgb(239, 242, 250)"}, {yPercent: 18})
                    //   .fromTo(activeBlock, {opacity: 1}, {opacity: 0}, "start+=20%")
                    //   .fromTo(inactiveBlock, {opacity: 0}, {opacity: 1}, "start+=50%")
                });
            }

            if (element.classList.contains("js-scroll-pack")) {
                let mm = gsap.matchMedia();
                const pack = element.querySelector(".js-pack");
                const bottomBlock = element.querySelector(".js-pack-bottom");

                mm.add("(min-width: 1024px)", () => {
                    let tl = gsap.timeline({
                        scrollTrigger: {
                            trigger: pack,
                            endTrigger: bottomBlock,
                            start: element.hasAttribute('data-start') ? element.getAttribute('data-start') : "center-=48px center",
                            end: "bottom 80%",
                            scrub: true,
                        //   markers: true
                        }
                    });

                    // add animations and labels to the timeline
                    tl.addLabel("start")
                        .fromTo(pack, {y: '0rem'}, {y: "15.5rem"})
                });
            }
        }

        new itsoftApp.modules.startLoad.callback(initScrollExemplar, libraries.gsap);
    }

    module.callback = initScrollActions;
});